import React from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { useATBRecs } from 'hooks/useATBRecs';
import styles from './AddToBasketRecommendations.module.css';

export function AddToBasketRecommendations() {
  const { recsHomeRef, recsAtbRef } = useSelectedSkuContext();
  const hasATBRecsCarousel = useATBRecs(recsAtbRef);

  return (
    <div ref={recsHomeRef}>
      <div
        ref={recsAtbRef}
        className={[
          styles.addToBasketRecsContainer,
          hasATBRecsCarousel ? styles.addToBasketRecsContainerHasCarousel : undefined,
        ]
          .filter(Boolean)
          .join(' ')}
        id="recs-atb-container"
        data-testid="recs-atb"
      />
    </div>
  );
}

export default AddToBasketRecommendations;
